import React, { useContext, useEffect, useState } from 'react';
import logger from '@greenlight/logger';
import { AnalyticsContext } from '../../ModularReduxAnalytics';
import { useUrlParams } from '../../helpers/useUrlParams';
import { useApp, useAppDispatchers } from '../../state/app';
import { useUser } from '../../state/user';
import { useToggles } from '../../state/toggles';
import { redirect } from '../../helpers/redirect';
import { nextGenRoutes } from '../App/routes';

import { UrlParamsType } from './types';
import { InApp } from './index';

const URL_PARAMS: Array<keyof UrlParamsType> = [
  'accessToken',
  'appOs',
  'appVersion',
  'authToken',
  'phoneNumber',
  'preregisteredUserId',
  'role',
  'segmentAnonymousId'
];

interface InAppContainerProps {
  children: React.ReactNode;
  accessToken?: string;
  authToken?: string;
}

function InAppContainer(props: InAppContainerProps) {
  const { segment } = useContext(AnalyticsContext);

  const {
    initializeInApp,
    registrationFailedAppMode,
    failedWriaUrlValidation
  } = useAppDispatchers();
  const { regAccessToken, appOs } = useApp();
  const { nextRegStep } = useUser();
  const { linkToExternalBrowserWithBadWriaUrl } = useToggles();
  const rawUrlParams = useUrlParams<keyof UrlParamsType>(URL_PARAMS);
  rawUrlParams.authToken = props.authToken;
  rawUrlParams.accessToken = props.accessToken;
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    // this is just listening for when the redux store is updated with
    // the data from the initializeInApp call
    if (nextRegStep === 'next_gen_onboarding') {
      redirect(nextGenRoutes.onboarding);
    } else if (regAccessToken && nextRegStep === 'register') {
      setInitialized(true);
    }
  }, [appOs, regAccessToken, nextRegStep]);

  return (
    <InApp
      /* eslint-disable-next-line react/no-children-prop */
      segment={segment}
      children={props.children}
      urlParams={rawUrlParams}
      initialized={initialized}
      updateAnonymousId={segment.updateAnonymousId}
      initializeInApp={(urlParams: UrlParamsType) => {
        initializeInApp(urlParams);
      }}
      onError={error => {
        if (linkToExternalBrowserWithBadWriaUrl.enabled) {
          failedWriaUrlValidation();
        } else {
          registrationFailedAppMode({ appOs: rawUrlParams.appOs, error });
        }
        logger.error(error);
      }}
    />
  );
}

export default InAppContainer;
